module.exports = __webpack_public_path__ + "img/Eclipse-2.a2b74632.jpg";